import React from "react";
import './link.css'
import {trackClick} from "../../utils/Analytics";
import {Link} from "react-router-dom";

export default function LinkComponent({className, children, link, target}) {
    return (
        <Link className={className} to={link} target={target ? target : ALinkTarget.external}
              onClick={() => trackClick("LinkComponent", link)}>{children}</Link>
    )
}

export const ALinkTarget = {
    internal: "_self",
    external: "_blank"
}
